import { apiAxios } from '@/api'
import type { PlaidInstitutionResult } from './bank-compatibility.types'

export const searchPlaidInstitutions = async (
  query: string
): Promise<PlaidInstitutionResult[]> => {
  const response = await apiAxios.get<PlaidInstitutionResult[]>(
    '/finances/api/v1/plaid/institution_search',
    { params: { q: query } }
  )
  return response.data
}
